import { render, staticRenderFns } from "./CustomFormModal.vue?vue&type=template&id=a85f35be&"
import script from "./CustomFormModal.vue?vue&type=script&lang=ts&"
export * from "./CustomFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFormModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports